import { Component, HostBinding, ChangeDetectionStrategy, ContentChild, forwardRef, QueryList } from '@angular/core';

import { EuiCardFooterActionButtonsComponent } from './eui-card-footer-action-buttons.component';
import { EuiCardFooterActionIconsComponent } from './eui-card-footer-action-icons.component';
import { EuiCardFooterMenuContentComponent } from './eui-card-footer-menu-content.component';

@Component({
    selector: 'eui-card-footer',
    templateUrl: './eui-card-footer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EuiCardFooterComponent {

    @HostBinding('class') string = 'eui-card-footer';
    // tslint:disable:max-line-length
    @ContentChild(forwardRef(() => EuiCardFooterActionButtonsComponent), { static: false }) actionButtons: QueryList<EuiCardFooterActionButtonsComponent>;
    @ContentChild(forwardRef(() => EuiCardFooterActionIconsComponent), { static: false }) actionIcons: QueryList<EuiCardFooterActionIconsComponent>;
    @ContentChild(forwardRef(() => EuiCardFooterMenuContentComponent), { static: false }) actionMenu: QueryList<EuiCardFooterMenuContentComponent>;

    constructor( ) {
    }
}
